import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UrlBuilder } from '../../core';
import { BreadcrumbService } from '../shared/breadcrumb-service/breadcrumb.service';

@Component({
    selector: 'sample-monitoring',
    template: require('./sample-monitoring.component.html'),
    styles: [require('./sample-monitoring.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SampleMonitoringComponent implements OnInit {
    public tabsCategories = [{
        name: 'Notifications',
        url: this.urlBuilder
            .esa()
            .sampletracking()
            .sampleMonitoring()
            .notifications()
            .url()
    }, {
        name: 'Notification Rules',
        url: this.urlBuilder
            .esa()
            .sampletracking()
            .sampleMonitoring()
            .notificationRules()
            .url()
    }];

    constructor(
        private readonly urlBuilder: UrlBuilder,
        private readonly breadcrumbService: BreadcrumbService
    ) { }

    public ngOnInit() {
    }
}
